import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';

/**
 * @deprecated This component should be replaced with Price component from @grandvisionhq/lib-visuals.
 */ const Price = (_param)=>{
    var { value , centAmount =true , currency , className , type ='default' , size ='custom' , 'aria-label': ariaLabel , fixedDecimals , prefix  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "value",
        "centAmount",
        "currency",
        "className",
        "type",
        "size",
        'aria-label',
        "fixedDecimals",
        "prefix"
    ]);
    const { locale  } = useIntl();
    const Component = type === 'strikethrough' ? 's' : 'span';
    const formattedPrice = formatPrice({
        locale,
        value,
        currency,
        isCentAmount: !!centAmount,
        fixedDecimals
    });
    const priceLabel = `${prefix ? `${prefix} ` : ''}${formattedPrice}`;
    const priceContent = React.useMemo(()=>{
        if (!ariaLabel) return priceLabel;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
            className: "sr-only"
        }, ariaLabel, "\xa0"), /*#__PURE__*/ React.createElement("span", null, priceLabel));
    }, [
        ariaLabel,
        priceLabel
    ]);
    return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, rest, {
        className: classnames('price', `price--${type}`, `price--${size}`, className)
    }), priceContent);
};

export { Price as default };
//# sourceMappingURL=Price.js.map
